import { useState, useEffect } from 'react';
import moment from 'moment-timezone';
import { PICKUP_CONSTANTS } from './constants';

/**
 * Custom hook for fetching and managing pickup-related data
 * Handles customer, delivery, and order data fetching with proper cleanup
 */
const usePickupData = (customer, getDelivery, logout, setCartOpen) => {
    const [startDate, setStartDate] = useState(new Date());
    const [filterDays, setFilterDays] = useState(PICKUP_CONSTANTS.ALL_WEEK_DAYS);
    const [isLoadingCustomer, setIsLoadingCustomer] = useState(false);

    // Memoized filtered days calculation
    const filteredDays = filterDays.filter((day) =>
        PICKUP_CONSTANTS.ALL_WEEK_DAYS.includes(day)
    );

    // Fetch customer and delivery info on mount
    useEffect(() => {
        if (!customer || !customer.ShippingZoneID) return;

        let isMounted = true;

        const fetchCustomerAndDelivery = async () => {
            try {
                setIsLoadingCustomer(true);

                if (!isMounted) return;

                const zoneId = customer.ShippingZoneID
                    .toLowerCase()
                    .replace('zone ', '')
                    .toUpperCase();

                const deliveryRes = await getDelivery(zoneId);

                if (!isMounted) return;

                setFilterDays(deliveryRes.delivery.available);

                // Calculate cutoff time in 24-hour format
                let cutoffHour = deliveryRes.cutoff.time;
                if (deliveryRes.cutoff.day === 'pm' && deliveryRes.cutoff.time !== 12) {
                    cutoffHour = deliveryRes.cutoff.time + 12;
                } else if (deliveryRes.cutoff.day === 'am' && deliveryRes.cutoff.time === 12) {
                    cutoffHour = 0;
                }

                // Calculate minimum pickup date
                const minDate = moment
                    .tz(PICKUP_CONSTANTS.TIMEZONE)
                    .add(deliveryRes.delivery.leadTime, 'days')
                    .add(cutoffHour, 'hours')
                    .toDate();

                setStartDate(minDate);
            } catch (error) {
                console.error('Error fetching customer/delivery info:', error);
                if (isMounted) {
                    logout();
                }
            } finally {
                if (isMounted) {
                    setIsLoadingCustomer(false);
                }
            }
        };

        fetchCustomerAndDelivery();
        setCartOpen(false);

        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customer]);

    // Fetch order data on mount


    return {
        startDate,
        filteredDays,
        isLoadingCustomer,
    };
};

export default usePickupData;

